import MenuButton from "app/ui/MenuButton";
import cn from "app/utils/classnames";

interface BuzzInButtonProps {
	onClick: () => void;
}

export default function BuzzInButton(props: BuzzInButtonProps) {
	return (
		<MenuButton
			className={cn(
				"text-lg",
				"px-2 py-3",
				"gap-2",
				"w-27 h-27",
				"flex-col justify-center"
			)}
			onClick={props.onClick}
			elevation="cn"
		>
			<div
				className={cn(
					"text-2xl",
					"border rounded-full",
					"w-10 h-10",
					"flex justify-center items-center"
				)}
			>
				!
			</div>
			Buzz-in
		</MenuButton>
	);
}